import { GET_LIST } from 'react-admin';

export const getLocations = warehouseId => ({
    type: GET_LIST,
    payload: { filter: { warehouseId } },
    meta: { resource: 'locations', fetch: GET_LIST, cancelPrevious: false },
});
